import { Component, Input, OnInit } from '@angular/core';
import {
  ICrudColumn,
  IOrder,
  IProfileEntity,
  OrderDirection,
  OrderEventStatus,
} from '@boma/supplier-portal/shared/entities';
import {
  HelperFunctionsService,
  OrdersService,
} from '@boma/supplier-portal/shared/services';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';

@Component({
  selector: 'boma-orders-table',
  templateUrl: './boma-orders-table.component.html',
  styleUrls: ['./boma-orders-table.component.scss'],
})

//TODO Implement loading, search and filters and custom action to create order.
export class BomaOrdersTableComponent implements OnInit {
  orders: IOrder[];
  pagination: {};
  @Input() customerId: string;

  currentPage: string = null;
  loaded = false;
  query = '';

  selectedStatuses: string[] = [];
  statusTypeOptions = [
    {
      label: 'All Active',
      value: null,
    },
    {
      label: 'Order Placed',
      value: OrderEventStatus.Placed,
    },
    {
      label: 'Processing',
      value: OrderEventStatus.Processing,
    },
    {
      label: 'Accepted',
      value: OrderEventStatus.Accepted,
    },
    {
      label: 'Loading',
      value: OrderEventStatus.Loading,
    },
    {
      label: 'Dispatched',
      value: OrderEventStatus.Dispatched,
    },
    {
      label: 'Fulfilled',
      value: OrderEventStatus.Fulfilled,
    },
    {
      label: 'Cancelled',
      value: OrderEventStatus.Cancelled,
    },
    {
      label: 'Returned',
      value: OrderEventStatus.Returned,
    },
  ];

  columns: ICrudColumn[] = [
    {
      field: 'orderDate',
      header: 'Date',
      type: 'Date',
    },

    // {
    //   field: 'locationDetails',
    //   header: 'Type',
    //   style: 'text-align:center',
    //   converter: (val) => {
    //     if (val?.receivingLocationDetails?.entityId === this.currentEntity.id) {
    //       return val.receivingLocationDetails.orderType || 'N/A';
    //     } else if (
    //       val?.supplyingLocationDetails?.entityId === this.currentEntity.id
    //     ) {
    //       return val.supplyingLocationDetails.orderType || 'N/A';
    //     } else {
    //       return 'Legacy';
    //     }
    //   },
    // },

    // UPDATE THIS TO COMPANY NAME AND LOCATION
    {
      field: 'receivingEntity',
      header: 'Customer',
      converter: (val) => val?.tradingName || '--',
    },

    {
      field: 'locationDetails',
      header: 'Receiving Location',
      type: 'location',
      converter: (val) =>
        val?.locationDetails?.receivingLocationDetails?.location,
    },

    // Only see this when the
    {
      field: 'entity', // sold from
      header: 'Supplier',
      converter: (val) => val?.tradingName || '--',
    },
    {
      field: 'locationDetails', // sold from
      header: 'Supplying Location',

      converter: (val) => val?.supplyingLocationDetails?.location?.name || '--',
    },

    {
      //Pointless in the event of sales location as it shows the customers location.
      field: 'originLocationName',
      header: 'Ordered From',
      converter: (val) => val || '--',
    },

    {
      field: 'logistics',
      header: 'Logisitcs',
      type: 'object',
      style: 'width: 180px; word-break: break-word;',
      converter: (val) => {
        return {
          vehicle: val?.deliveryVehicleName || '--',
          driver:
            val?.deliveryPerson?.firstName && val?.deliveryPerson?.surname
              ? val?.deliveryPerson?.firstName +
                ' ' +
                val?.deliveryPerson?.surname
              : '',
          contact: val?.deliveryPerson?.contactNumber || '', // TODO api requires to return the drivers phone number to the order
        };
      },
    },

    {
      field: 'createdBy',
      header: 'Created By',
      converter: (val) => val?.firstName + ' ' + val?.surname || '--',
    },

    {
      field: 'reference',
      header: 'Reference Number',
      style: 'width: 100px; word-break: break-word;',
    },

    { field: 'status', header: 'Status' },
    {
      field: 'events',
      header: 'Status Updated',
      type: 'fullobject',
      converter: (val) =>
        this.helperService.friendlyDate(
          val.events.find((x) => {
            return x.type === val.status;
          })?.createdAt,
          false
        ),
    },

    {
      field: 'charges',
      type: 'currency',
      header: 'Total',
      converter: (val) =>
        val
          .map((item) => Number.parseFloat(item.total))
          .reduce((acc, curr) => acc + curr, 0),
    },
  ];
  private currentEntity: IProfileEntity;

  constructor(
    private store: Store,
    private orderService: OrdersService,
    private helperService: HelperFunctionsService,
    private toastSvc: MessageService
  ) {}

  ngOnInit(): void {
    this.store
      .select(getSelectedOrganizationInfo)
      .pipe(take(1))
      .subscribe((org) => {
        this.currentEntity = org;
        this.getOrders();
      });
  }

  getOrders() {
    this.loaded = false;
    this.orderService
      .getOrders(
        this.currentEntity.id,
        [],
        this.currentPage,
        '25',
        this.query,
        OrderDirection.Outbound,
        null,
        [this.customerId],
        null,
        this.selectedStatuses,
        null
      )
      .subscribe(
        (payload) => {
          this.loaded = true;
          this.orders = payload.items;
          this.pagination = {
            totalItems: payload.totalItems,
            totalPages: payload.totalPages,
            previousPage: payload.previousPage,
            nextPage: payload.nextPage,
          };
        },
        (error) => {
          this.loaded = true;
          this.toastSvc.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error loading orders. Please try again',
          });
        }
      );
  }

  handleSearchQueryChanged(query) {
    this.query = query;
    this.getOrders();
  }

  handleNextPageClicked(ev) {
    if (ev === this.currentPage) return;
    this.currentPage = ev;
    this.getOrders();
  }

  handleChangePageClicked(ev = null) {
    if (ev === this.currentPage) return;
    this.currentPage = ev;
    this.getOrders();
  }

  handleFilterSelectionChange(event) {
    //Status

    this.selectedStatuses = [event?.value ? event.value : event];
    this.getOrders();
  }
}
